/* PROJ-91 Geburtsblumen-Kette (ILB22) — Engine (Blumen-Motiv + optionaler
 * Name vorne, Rueckseiten-Text hinten). GETEILT: byte-identisch in
 * distantlines/assets/ und shared_frontend/ auf dem Render-Server
 * (Parity-Gate tools/jewelry-parity.mjs, Eintrag SHARED).
 *
 * Haengt an ZWEI Dateien, die VORHER geladen sein muessen:
 *   jewelry-engine.js         -> window.jewelryFontDefs (Gravurschrift
 *                                'DL Gravur' = Jost Light als WOFF2-data-URI;
 *                                ohne sie rastert SVG-als-<img> fontlos —
 *                                Lehre "svg-als-img-webfont-falle")
 *   jewelry-blumen-motive.js  -> window.jewelryBlumenMotive (24 Motive)
 *
 * Klassisches Script, KEINE ES-Imports/-Exports, synchron und DOM-frei
 * (Server-Print-Mode und Theme-Modul laden es gleich).
 *
 * config (configJson() aus jewelry-blumen.js):
 *   { produkt: 'geburtsblumen-kette', version: 1,
 *     farbe: 'silber'|'gold'|'rose',
 *     monat: 1..12,
 *     blume: '<key aus window.jewelryBlumenMotive>',
 *     name: 'Emma'|'',          // optional, max 14 Zeichen
 *     rueckseite: 'freier Text'|'' }
 *
 * GEOMETRIE (viewBox 1024 = runder Coin Ø 16 mm, Inspire ILB22;
 * 1 px = 0,0156 mm):
 *   - Das Motiv ist ein reiner FUELLPFAD (Stempel-Stil, fill #000, keine
 *     strokes) und wird contain-gefittet mittig eingebettet.
 *   - ⚠️ Die `viewBox`-Angabe der Motiv-Datenbank ist NICHT die Bounding-Box
 *     der Pfade: sie stammt 1:1 aus den Quell-SVGs, deren Pfade um den
 *     URSPRUNG liegen (x ~ -283..+320), waehrend die viewBox eine Region bei
 *     x ~ 955..1590 deklariert. Nachgemessen 30.08. ueber alle 24 Motive
 *     (Bezier-Flattening, 16 Stuetzstellen je Segment): die deklarierte Box
 *     ist um ~1000 px in x verschoben und 10-30 % zu gross. Wer damit fittet,
 *     schiebt das Motiv komplett aus dem Coin. Deshalb rechnet diese Engine
 *     die echte Bbox EINMAL je Motiv selbst aus (bboxVon, gecacht) — gleiche
 *     Rechnung in Vorschau und Gravur, kein Drift.
 *   - Nutzbarer Kern: der Coin ist ein Kreis mit R 512; als sichere
 *     Gravur-Zone gilt R_SICHER 430 (84 %). Die Schwester-Engines bleiben
 *     mit ihrer aeussersten Tinte bei ~374 (jewelry-letters-engine.js:
 *     R_POS 300 + halbe Versalhoehe), liegen also innerhalb.
 *   - VORNE, zwei Faelle:
 *     ohne Name  Motiv 700 px hoch, mittig auf (512, 512). Breitestes Motiv
 *                (holly, 516x896) wird dabei 403 px breit -> Eckradius
 *                sqrt(350² + 202²) = 404 < 430 ✓
 *     mit Name   Motiv 560 px hoch auf (512, 430) — Unterkante 710 —, der
 *                Name darunter mit optischer Mitte auf 780. Groesse aus der
 *                Fit-Leiter (max. 90 px), Grundlinie selbst gerechnet
 *                (KEIN dominant-baseline, Chrome-Messungs-Lehre 23.08.).
 *                Fit-Breite NAME_FIT 570 statt der 820 des runden Coins:
 *                auf Hoehe der Unterlaengen (y ~ 830) ist der sichere Kreis
 *                nur noch 2 x 289 px breit — nachgerechnet, nicht geschaetzt.
 *   - HINTEN: freier Text, max. RUECK_MAX Zeichen, 1-3 Zeilen (balancierter
 *     Wortgrenzen-Umbruch), Fit-Leiter 1:1 aus jewelry-letters-engine.js
 *     (runder Coin -> dieselbe FIT_BREITE 820). Harte Mindestgroesse
 *     RUECK_MIN 58 px ≈ 0,65 mm Versal: was da nicht passt, lehnt das Gate
 *     ab. Final per Mustergravur. */
(function (w) {
  'use strict';

  const INK = '#000';
  const CX = 512, CY = 512;
  const GRAVUR = "'DL Gravur', 'Jost', sans-serif";
  const VERSAL = 0.72;      /* Versalhoehe Jost Light in em (Schaetzung) */

  /* ---------- Motiv-Datenbank + gemessene Bounding-Box ---------- */
  function alleMotive() { return w.jewelryBlumenMotive || {}; }
  function motiv(key) { return alleMotive()[key] || null; }

  /* Stuetzstellen je Kubik-Segment. 16 reicht: der Fehler gegen die exakte
     Extremwert-Rechnung liegt bei diesen Pfaden unter 0,5 px im 1000er-Raum
     (nachgerechnet 30.08.), und ein leicht zu kleiner Fit ist unkritisch —
     ein zu grosser waere es nicht. */
  const BBOX_STUETZEN = 16;
  const BBOX_CACHE = {};

  /* Bbox eines Pfad-Strings. Die Motive nutzen ausschliesslich M/C/Z
     (verifiziert ueber alle 24 Eintraege); L und implizite Fortsetzung nach
     M sind trotzdem abgedeckt, unbekannte Kommandos werden uebersprungen. */
  function bboxVon(d) {
    const toks = String(d).match(/[A-Za-z]|-?\d+(?:\.\d+)?(?:[eE][-+]?\d+)?/g);
    if (!toks) return null;
    let i = 0, px = 0, py = 0, sx = 0, sy = 0, cmd = '';
    let minx = Infinity, maxx = -Infinity, miny = Infinity, maxy = -Infinity;
    function merk(x, y) {
      if (x < minx) minx = x;
      if (x > maxx) maxx = x;
      if (y < miny) miny = y;
      if (y > maxy) maxy = y;
    }
    function zahl() { return parseFloat(toks[i++]); }
    while (i < toks.length) {
      const t = toks[i];
      if (/^[A-Za-z]$/.test(t)) {
        cmd = t;
        i++;
        if (cmd === 'Z' || cmd === 'z') { px = sx; py = sy; }
        continue;
      }
      if (cmd === 'M') {
        px = zahl(); py = zahl(); sx = px; sy = py;
        merk(px, py);
        cmd = 'L';           /* implizite Fortsetzung nach M ist L (SVG-Spec) */
        continue;
      }
      if (cmd === 'L') { px = zahl(); py = zahl(); merk(px, py); continue; }
      if (cmd === 'C') {
        const x1 = zahl(), y1 = zahl(), x2 = zahl(), y2 = zahl(), x = zahl(), y = zahl();
        for (let s = 1; s <= BBOX_STUETZEN; s++) {
          const u = s / BBOX_STUETZEN, v = 1 - u;
          const a = v * v * v, b = 3 * v * v * u, c = 3 * v * u * u, e = u * u * u;
          merk(a * px + b * x1 + c * x2 + e * x, a * py + b * y1 + c * y2 + e * y);
        }
        px = x; py = y;
        continue;
      }
      i++;                   /* unbekanntes Kommando: Zahl verwerfen */
    }
    if (!isFinite(minx) || !isFinite(miny)) return null;
    return { x: minx, y: miny, w: maxx - minx, h: maxy - miny };
  }

  function motivBbox(key) {
    if (!(key in BBOX_CACHE)) {
      const mo = motiv(key);
      BBOX_CACHE[key] = mo ? bboxVon(mo.d) : null;
    }
    return BBOX_CACHE[key];
  }

  /* Motiv contain-gefittet: Bbox-Mitte landet auf (cx, cy), die groessere
     Seite auf boxW bzw. boxH. Alle Motive sind deutlich hoeher als breit
     (Verhaeltnis 0,33-0,58), praktisch fittet also immer die Hoehe. */
  function motivSVG(key, cx, cy, boxW, boxH, fill) {
    const mo = motiv(key);
    const b = motivBbox(key);
    if (!mo || !b || !(b.w > 0) || !(b.h > 0)) return '';
    const s = Math.min(boxW / b.w, boxH / b.h);
    const tx = cx - s * (b.x + b.w / 2);
    const ty = cy - s * (b.y + b.h / 2);
    return `<g transform="translate(${tx.toFixed(2)} ${ty.toFixed(2)}) scale(${s.toFixed(5)})">` +
      `<path d="${mo.d}" fill="${fill || INK}"/></g>`;
  }

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Normalisierung ---------- */
  /* Der Editor erzwingt, dass die Blume zum Monat gehoert; die Engine
     rendert trotzdem das, was in der Config steht (die Blume IST das Motiv).
     Nur wenn der Key unbekannt ist, wird ueber den Monat nachgeschlagen —
     so bleibt eine halb kaputte Config sichtbar statt leer. Verbindlich
     prueft der Server-Validator. */
  function blumenFuerMonat(monat) {
    const m = alleMotive();
    return Object.keys(m).filter(k => m[k].monat === monat).sort();
  }
  function normMonat(v) {
    const n = parseInt(v, 10);
    return n >= 1 && n <= 12 ? n : 0;
  }
  function normBlume(cfg) {
    const key = String((cfg || {}).blume || '');
    if (motiv(key)) return key;
    const monat = normMonat((cfg || {}).monat);
    if (monat) {
      const kandidaten = blumenFuerMonat(monat);
      if (kandidaten.length) return kandidaten[0];
    }
    return '';
  }

  /* ---------- Vorderseite ---------- */
  const R_SICHER = 430;         /* sichere Gravur-Zone (Radius) — Doku oben */
  const MOTIV_BOX = 700;        /* ohne Name: Motiv-Hoehe */
  const MOTIV_CY = CY;          /* ohne Name: mittig */
  const MOTIV_BOX_NAME = 560;   /* mit Name: kleiner und hoeher */
  const MOTIV_CY_NAME = 430;
  const NAME_CY = 780;          /* optische Mitte der Namenszeile */
  const NAME_STUFEN = [90, 80, 70, 62];
  const NAME_MIN = 55;          /* wie jewelry-birth-engine.js (≈0,62 mm Versal) */
  const NAME_FIT = 570;         /* nutzbare Breite auf Hoehe der Namenszeile */
  const NAME_MAX_ZEICHEN = 14;
  const GLYPH_EM = 0.55;

  /* Laufweiten-Schaetzung wie jewelry-letters-engine.js: Versalien zaehlen
     1,3 Einheiten, alles andere 1 — bewusst grob, aber identisch in
     Vorschau und Gravur. */
  function effLaenge(t) {
    let n = 0;
    for (const ch of t) n += /[A-ZÀ-ÞĄĆĘŁŃŚŹŻА-ЯЁ]/.test(ch) ? 1.3 : 1;
    return n;
  }

  /* Groesste Stufe, bei der der Name in NAME_FIT passt; darunter stufenlos
     bis NAME_MIN. null = zu lang. */
  function nameGroesse(name) {
    const em = effLaenge(name) * GLYPH_EM;
    if (!(em > 0)) return null;
    for (const gr of NAME_STUFEN) if (gr * em <= NAME_FIT) return gr;
    const gr = Math.floor(NAME_FIT / em);
    return gr >= NAME_MIN ? gr : null;
  }
  function normName(v) {
    return String(v == null ? '' : v).trim().replace(/\s+/g, ' ');
  }
  function nameZuLang(name) {
    const n = normName(name);
    if (!n) return false;
    if ([...n].length > NAME_MAX_ZEICHEN) return true;
    return nameGroesse(n) == null;
  }

  function nameSVG(name, cy) {
    const gr = nameGroesse(name);
    if (!gr) return '';
    const y = (cy || NAME_CY) + gr * VERSAL / 2;
    /* Notnagel wie jewelry-herz-engine.js datumSVG: sollte die
       Laufweiten-Schaetzung je danebenliegen, presst textLength die Zeile
       hart in die Fit-Breite, statt sie aus dem Coin laufen zu lassen. */
    const breite = gr * effLaenge(name) * GLYPH_EM;
    const not = breite > NAME_FIT ? ` textLength="${NAME_FIT}" lengthAdjust="spacingAndGlyphs"` : '';
    return `<text x="${CX}" y="${y.toFixed(1)}" font-family="${GRAVUR}" font-size="${gr}" text-anchor="middle" fill="${INK}"${not}>${esc(name)}</text>`;
  }

  /* PROJ-107 (25.10.2026, Geburtsblumen-Kette als Herz): cfg.form 'herz' = Herz ILB45. Ohne Name sitzt die Blume
     wie auf der abgenommenen Herz-Rueckseite (jewelry-abdruck-engine.js, Dominik 24.10.): Mitte der gravierbaren
     Hoehe y 528, contain-gefittet ins Herz. Mit Name (NEU, ohne Vorlage): Namenszeile bei y 680, dort ist das Herz
     651 breit (Sehnentabelle), die Coin-Regel NAME_FIT 570 passt mit Rand, Schriftgroesse wie auf dem Coin; die Blume
     fuellt den Raum darueber (Oberkante Kerbe + Rand bis 30 ueber der Namenszeile). Herz-Masse aus
     w.jewelryHerzRechteckPasst (Abdruck-Engine, muss geladen sein). Coin byte-gleich. */
  const HERZ_NAME_CY = 680, HERZ_Y_MIN = 118, HERZ_Y_MAX = 938;
  function herzFrontSVG(c, key, name, mitName) {
    const passt = w.jewelryHerzRechteckPasst;
    if (typeof passt !== 'function') throw new Error('jewelryBlumen: form herz braucht jewelry-abdruck-engine.js (jewelryHerzRechteckPasst)');
    const b = motivBbox(key);
    const verh = b && b.h > 0 ? b.w / b.h : 0.58;
    let s = w.jewelryFontDefs();
    if (!mitName) {
      const cy = (HERZ_Y_MIN + HERZ_Y_MAX) / 2;
      let box = 760;
      while (box > 200 && !passt(CX, cy, box * verh, box)) box -= 5;
      s += motivSVG(key, CX, cy, box, box);
    } else {
      const gr = nameGroesse(name);
      const unten = HERZ_NAME_CY - gr * VERSAL / 2 - 30;
      let box = 600, cy = 0;
      while (box > 200) {
        cy = unten - box / 2;
        if (passt(CX, cy, box * verh, box)) break;
        box -= 5;
      }
      s += motivSVG(key, CX, cy, box, box);
      s += nameSVG(name, HERZ_NAME_CY);
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">${s}</svg>`;
  }

  function frontSVG(cfg) {
    const c = cfg || {};
    if (c.form === 'herz') {
      const key = normBlume(c), name = normName(c.name);
      return herzFrontSVG(c, key, name, !!name && !nameZuLang(name));
    }
    let s = w.jewelryFontDefs();
    const key = normBlume(c);
    const name = normName(c.name);
    /* Ein zu langer Name wird NICHT graviert (das Kauf-Gate im Editor haelt
       ihn ohnehin auf) — dann gilt das Layout ohne Name. */
    const mitName = !!name && !nameZuLang(name);
    if (mitName) {
      s += motivSVG(key, CX, MOTIV_CY_NAME, MOTIV_BOX_NAME, MOTIV_BOX_NAME);
      s += nameSVG(name);
    } else {
      s += motivSVG(key, CX, MOTIV_CY, MOTIV_BOX, MOTIV_BOX);
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">${s}</svg>`;
  }

  /* ---------- Rueckseite: freier Text, 1-3 Zeilen ---------- */
  /* Logik 1:1 aus jewelry-letters-engine.js (gleicher runder Rohling ILB22,
     deshalb auch dieselbe FIT_BREITE 820). */
  const RUECK_MAX = 60;
  const RUECK_STUFEN = [84, 74, 66, 58];
  const RUECK_MIN = 58;
  const RUECK_ZEILEN_MAX = 3;
  const FIT_BREITE = 820;   /* nutzbare Breite im 1024er-viewBox (Kette-Muster) */
  const ZEILE_EM = 1.35;    /* Zeilenabstand in em */

  let FIT = FIT_BREITE;   /* PROJ-107: Herz 620 wie jewelry-herz-engine.js */
  const zeilePasst = (t, gr) => effLaenge(t) * gr * GLYPH_EM <= FIT;

  /* Greedy-Umbruch an Wortgrenzen fuer eine feste Groesse; null wenn ein
     Einzelwort nicht passt oder mehr als RUECK_ZEILEN_MAX Zeilen noetig. */
  function umbruch(text, gr) {
    const worte = text.split(/\s+/).filter(Boolean);
    const zeilen = [];
    let akt = '';
    for (const wort of worte) {
      if (!zeilePasst(wort, gr)) return null;
      const test = akt ? akt + ' ' + wort : wort;
      if (zeilePasst(test, gr)) akt = test;
      else { zeilen.push(akt); akt = wort; }
    }
    if (akt) zeilen.push(akt);
    return zeilen.length <= RUECK_ZEILEN_MAX ? zeilen : null;
  }

  /* Groesste Stufe, bei der der Text in max. 3 Zeilen passt. null = zu lang. */
  function rueckLayout(text) {
    for (const gr of RUECK_STUFEN) {
      const zeilen = umbruch(text, gr);
      if (zeilen) return { gr, zeilen };
    }
    return null;
  }
  function rueckseiteZuLang(text, form) {
    const t = (text || '').trim().replace(/\s+/g, ' ');
    if (!t) return false;
    if ([...t].length > RUECK_MAX) return true;
    FIT = form === 'herz' ? 620 : FIT_BREITE;
    try { return rueckLayout(t) == null; } finally { FIT = FIT_BREITE; }
  }

  function backSVG(cfg) {
    FIT = cfg && cfg.form === 'herz' ? 620 : FIT_BREITE;
    try { return backSVGInnen(cfg); } finally { FIT = FIT_BREITE; }
  }
  function backSVGInnen(cfg) {
    let s = w.jewelryFontDefs();
    const t = ((cfg || {}).rueckseite || '').trim().replace(/\s+/g, ' ');
    if (t) {
      const lay = rueckLayout(t);
      if (lay) {
        const lh = lay.gr * ZEILE_EM;
        const n = lay.zeilen.length;
        for (let i = 0; i < n; i++) {
          /* Blockmitte auf der Coin-Mitte; Grundlinie je Zeile eine halbe
             Versalhoehe unter ihrer optischen Mitte. */
          const yMitte = CY + (i - (n - 1) / 2) * lh;
          const y = yMitte + lay.gr * VERSAL / 2;
          s += `<text x="${CX}" y="${y.toFixed(1)}" font-family="${GRAVUR}" font-size="${lay.gr}" text-anchor="middle" fill="${INK}">${esc(lay.zeilen[i])}</text>`;
        }
      }
    }
    return `<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">${s}</svg>`;
  }

  /* ---------- Kachel-Vorschau (nur Editor-UI) ---------- */
  /* Die Blumen-Kacheln im Wizard zeigen EXAKT die Gravur-Form. Der Fit
     steckt hier in derselben Funktion wie beim Druck — waere er im Modul
     nachgebaut, wuerden Kachel und Gravur mit der Zeit auseinanderlaufen. */
  function vorschauSVG(key, px) {
    const p = px || 96;
    const rand = p * 0.06;
    const inner = motivSVG(key, p / 2, p / 2, p - 2 * rand, p - 2 * rand);
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${p}" height="${p}" viewBox="0 0 ${p} ${p}" aria-hidden="true">${inner}</svg>`;
  }

  w.jewelryBlumenFrontSVG = frontSVG;
  w.jewelryBlumenBackSVG = backSVG;
  w.jewelryBlumenRueckseiteZuLang = rueckseiteZuLang;
  w.jewelryBlumenNameZuLang = nameZuLang;
  w.jewelryBlumenRueckseiteMax = RUECK_MAX;
  w.jewelryBlumenNameMax = NAME_MAX_ZEICHEN;
  w.jewelryBlumenFuerMonat = blumenFuerMonat;
  w.jewelryBlumenMotivVorschauSVG = vorschauSVG;
  /* PROJ-116 (24.10.2026): die Abdruck-Engine setzt die Blume auf die Herz-Rueckseite in ein eigenes Kaestchen
     (Herz-Innenmass statt Coin-Box); gleiche Normalisierung und derselbe Fit wie frontSVG. */
  w.jewelryBlumenMotivSVG = (cfg, cx, cy, boxW, boxH) => motivSVG(normBlume(cfg || {}), cx, cy, boxW, boxH);
  /* Seitenverhaeltnis (Breite/Hoehe) der Motiv-Bbox, damit die Herz-Rueckseite das Kaestchen passend waehlt */
  w.jewelryBlumenMotivVerhaeltnis = (cfg) => { const b = motivBbox(normBlume(cfg || {})); return b && b.h > 0 ? b.w / b.h : 0.58; };
})(window);
